import mobx, { observable, action, computed } from 'mobx';
import api from '../../api';
import Results from './results';
import Menu from './menu';
import igStore from '~/components/ig/store';
import { ResultsLive } from '~/web-frontend-core/store/results/ResultsLive';
import { SITE_TYPE } from '~/config';
export class ResultStore {

	@observable isLoading = 0;
	@observable menu = {};
	@observable results = {};
	@observable mode = '';
	@observable cashboxId = 2;
	@observable result = {
		status: 0,
		text: '',
		type: 0
	};

   constructor() {
      this.initResultsLiveWSS();
   }

   initResultsLiveWSS() {
      const siteType = SITE_TYPE.IRM_CUPIS;
      const { url: webSocketURL, getSocket } = igStore;
      this.liveResults = new ResultsLive({
         webSocketURL,
         getSocket,
         siteType,
         lng: 1049,
      });
   }

	@action setError(text, type) {
		this.result.status = 1;
		this.result.text = text;
		this.result.type = type ? type : 0;
	}

	@action clearError() {
		this.result.status = 0;
		this.result.text = '';
		this.result.type = 0;
	}

	@action init(mode) {
		this.reset();
		this.mode = mode;
		this.getData();
	}

	@action reset() {
		this.isLoading = 0;
		this.mode = '';
		// this.menu = '';
		// this.results = '';
		this.clearError();
	}

	@action setCashboxModeId(id) {
		if (!id || this.cashboxId == id) { return;}
		this.cashboxId = id
      this.initResultsLiveWSS();
	}

	@action getData(){
		api[`${this.mode}Results`].getFilter().then(
			action( data => {
				if (data.code == "OK") {
					this.menu = new Menu(this, data.result);
					this.results = new Results(this);
				} else {
					this.setError(data.text ? data.text : 'SERVER_TEMPORARILY_DOWN');
				}
			}))
      .catch(action(err => {
        this.setError('SERVER_TEMPORARILY_DOWN');
      }))
      .finally(action(() => { this.isLoading = 1 }));
	}
}

export default new ResultStore();


// WEBPACK FOOTER //
// ./src/stores/resultStore/index.js